import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M3.164 0c.262 0 .475.212.475.475v1.898h8.543V.475a.475.475 0 0 1 .949 0v1.898h1.107c1.049 0 1.899.85 1.899 1.898v8.514a4.3 4.3 0 0 0-.95-.548V6.803H.95v10.355c0 .524.425.949.95.949H9.73q.264.52.655.95H1.898A1.9 1.9 0 0 1 0 17.156V4.272c0-1.048.85-1.898 1.898-1.898h.791V.475c0-.263.213-.475.475-.475m12.024 4.271v1.583H.948V4.27a.95.95 0 0 1 .95-.949h12.34a.95.95 0 0 1 .948.95",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M13.555 12.391a3.797 3.797 0 1 0 0 7.594 3.797 3.797 0 0 0 0-7.594m-4.746 3.797a4.746 4.746 0 1 1 9.492 0 4.746 4.746 0 0 1-9.492 0m4.485-1.48c.262 0 .474.213.474.475v1.108h.95a.475.475 0 0 1 0 .949h-1.899v-2.057c0-.262.213-.474.475-.474",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }